import { useValuation } from '@api/useValuation'
import { Horizontal, Vertical } from '@gravitate-js/excalibrr'
import React, { useEffect, useState } from 'react'

import { SwingReportGrid } from './SwingReportGrid'
import { SwingReportSelectorsGrid } from './SwingReportSelectorsGrid'

export function SwingReport() {
  const [headerData, setHeaderData] = useState({ site: null, product: null })
  const [selectedICI, setSelectedICI] = useState(null)
  const { getHistoryByICIQuery } = useValuation()
  const { data: historyByICI, isFetching: isFetchingICI, isError: isErrorICI } = getHistoryByICIQuery(selectedICI)
  return (
    <Horizontal style={{ padding: '1rem', gap: '1rem', height: '100%', width: '100%' }}>
      <Vertical flex={1} height='100%'>
        <SwingReportSelectorsGrid setHeaderData={setHeaderData} setSelectedICI={setSelectedICI} />
      </Vertical>
      <Vertical flex={2}>
        <SwingReportGrid
          headerData={headerData}
          historyByICI={historyByICI}
          isLoading={isFetchingICI}
          isError={isErrorICI}
        />
      </Vertical>
    </Horizontal>
  )
}
